import { keyframes } from '@emotion/react';
import theme from '@styles/theme';
const pulseDim = keyframes`
  0%, 100% { opacity: 0.38; }
  50% { opacity: 0.58; }
`;
export default {
  configuratorContainer: {
    position: 'relative',
    minHeight: '100vh',
    width: '100%'
  },
  transitionOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: theme.zIndex.barUp,
    pointerEvents: 'auto',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundColor: 'rgba(20, 20, 20, 0.28)',
      animation: `${pulseDim} 1.6s ease-in-out infinite`
    },
    '& > div': {
      bg: 'transparent'
    }
  },
  productCardDocumentContainer: {
    position: 'relative',
    width: '100%',
    padding: ['0', '0', '0px 20px', '0px 20px', '0px 20px', '0px 20px'],
    height: 'calc(100vh - 64px)',
    overflow: 'hidden',
    '.swiper': {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    '.swiper-scrollbar': {
      width: '2px',
      right: 0
    },
    '.swiper-scrollbar-drag': {
      backgroundColor: theme.rawColors.darkGrey700
    },
    '.swiper-slide': {
      width: '100%',
      height: 'auto'
    }
  }
};